import tw from "twin.macro";

export const StyledInput = tw.input`
	hidden
`;
